import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Components
import NoSearchResults from 'components/NoSearchResults';
import ResponsiveTable from 'components/ResponsiveTable';

// Child
import ForecastsTableHead from './components/ForecastsTableHead';
import ForecastsTableRow from './components/ForecastsTableRow';

// // Selectors
import { selectEntityIds } from './selectors';

interface Props {
    entityIds?: number[];
}

export class ForecastsTable extends React.PureComponent<Props> {
    render() {
        const { entityIds } = this.props;
        if (!entityIds || !entityIds.length) {
            return <NoSearchResults />;
        }
        return (
            <ResponsiveTable>
                <Table
                    sortable
                    striped
                    singleLine
                    unstackable
                    size="small"
                    selectable
                >
                    <ForecastsTableHead />
                    <Table.Body>
                        {entityIds.map(id => (
                            <ForecastsTableRow entityId={id} key={id} />
                        ))}
                    </Table.Body>
                </Table>
            </ResponsiveTable>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    entityIds: selectEntityIds
});

export default connect(mapStateToProps)(ForecastsTable);
